import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';
import { useConfigNegociacao } from '../negociacao';
import { usePrimeirosPassos } from '../pages/PrimeirosPassos';
import { useContagemRetornos } from '../pages/Retornos';
import { FaixaTeste, Logo, TelaBloqueio } from './Marca';
import { TelaCriarSenha } from './SenhaTemporaria';
import { Icon } from './ui';

export function Layout() {
  const { me, pode, sair, trocarEmpresa } = useAuth();
  // Empresa bloqueada ou senha temporária: nada de consultas (voltariam 403) até liberar
  const liberado = !!me && !me.empresa.bloqueio && !me.usuario.trocarSenha;
  const retornos = useContagemRetornos(liberado);
  const admin = liberado && pode('CONFIGURACOES_GERENCIAR');
  const passos = usePrimeirosPassos(admin);
  const negociacao = useConfigNegociacao(liberado);
  if (!me) return null;
  if (me.empresa.bloqueio) return <TelaBloqueio />;
  if (me.usuario.trocarSenha) return <TelaCriarSenha />;
  const outras = me.empresas.filter((e) => e.tenantId !== me.empresa.id && e.tenantStatus !== 'CANCELADO');
  return (
    <div className="app">
      <nav className="sidebar" aria-label="Principal">
        <div className="brand">
          <Logo size={32} />
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span style={{ fontSize: 13.5 }}><b>Garimpa</b> <span style={{ color: 'var(--text-2)' }}>Vendas</span></span>
            <span className="small faint" title={me.empresa.nome} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {me.empresa.nome} · {me.empresa.status === 'TRIAL' ? 'teste grátis' : `plano ${me.empresa.plano?.nome ?? '—'}`}
            </span>
          </div>
        </div>
        {passos.data?.mostrar && (
          <NavLink to="/primeiros-passos" className="nav nav-ouro">
            <Icon name="check" />Primeiros passos<span className="count">{passos.data.feitos}/{passos.data.total}</span>
          </NavLink>
        )}
        <NavLink to="/" end className="nav"><Icon name="dashboard" />Dashboard</NavLink>
        <NavLink to="/clientes" className="nav"><Icon name="clientes" />Clientes</NavLink>
        {pode('CLIENTES_CRIAR') && <NavLink to="/prospeccao" className="nav"><Icon name="prospeccao" />Prospecção</NavLink>}
        {negociacao.data?.ativa && <NavLink to="/negociacoes" className="nav"><Icon name="dinheiro" />Negociações</NavLink>}
        <NavLink to="/campanhas" className="nav"><Icon name="campanhas" />Campanhas</NavLink>
        <NavLink to="/retornos" className="nav"><Icon name="agenda" />Retornos{!!retornos.data && <span className="count" aria-label={`${retornos.data} pendentes`}>{retornos.data}</span>}</NavLink>
        <NavLink to="/templates" className="nav"><Icon name="template" />Templates</NavLink>
        {pode('USUARIOS_GERENCIAR') && <NavLink to="/usuarios" className="nav"><Icon name="usuarios" />Usuários</NavLink>}
        <NavLink to="/configuracoes" className="nav"><Icon name="config" />Configurações</NavLink>
        <div className="sep" />
        <div className="user">
          <span style={{ fontSize: 13, fontWeight: 500 }}>{me.usuario.nome}</span>
          <span className="small faint">{me.perfil === 'ADMIN' ? 'Administrador(a)' : 'Vendedor(a)'}</span>
          {outras.length > 0 && (
            <label className="field">
              <span>Trocar de empresa</span>
              <select className="select" value="" onChange={(e) => e.target.value && trocarEmpresa(e.target.value)}>
                <option value="">Selecione…</option>
                {outras.map((e) => (
                  <option key={e.tenantId} value={e.tenantId} disabled={e.tenantStatus === 'BLOQUEADO'}>
                    {e.tenantNome}{e.tenantStatus === 'BLOQUEADO' ? ' (bloqueada)' : ''}
                  </option>
                ))}
              </select>
            </label>
          )}
          <NavLink to="/conta" className="btn sm">Minha conta</NavLink>
          <button className="btn sm" onClick={() => sair()}><Icon name="sair" size={14} />Sair</button>
        </div>
      </nav>
      <main className="main">
        <FaixaTeste />
        <Outlet />
      </main>
    </div>
  );
}
